<template>
  <Toast />
  <ConfirmPopup></ConfirmPopup>
  <div class="subscriber-view">
    <div class="header-section">
      <div class="header-content">
        <div class="title-section">
          <h1 class="title">Global Catalogs & Marketplaces</h1>
          <span class="catalog-badge">Discovery Sources</span>
        </div>
      </div>
    </div>

    <section class="subscription-section">
      <div class="subscription-card">
        <div class="card-header">
          <div class="header-content">
            <p class="section-description">
              Add external catalogs or marketplaces that should appear as global
              publish targets.
            </p>
          </div>
        </div>

        <div class="input-section">
          <div class="input-group">
            <div class="input-row catalog-row">
              <!-- <div class="input-container">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M4 7h16M4 12h16M4 17h16"
                    stroke="currentColor"
                    stroke-width="2"
                  />
                </svg>
                <input
                  v-model="newCatalogName"
                  type="text"
                  placeholder="Catalog name"
                  class="endpoint-input"
                />
              </div> -->
              <div class="input-container">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                    stroke="currentColor"
                    stroke-width="2"
                  />
                  <path
                    d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
                    stroke="currentColor"
                    stroke-width="2"
                  />
                </svg>
                <select
                  v-model="selectedPortalCatalogId"
                  class="endpoint-input"
                  @change="handlePortalCatalogSelect"
                >
                  <option disabled value="">Select catalog</option>
                  <option
                    v-for="catalog in portalCatalogs"
                    :key="catalog.id"
                    :value="catalog.id"
                  >
                    {{ catalog.name }}
                  </option>
                </select>
              </div>
              <div class="input-container select-container">
                <select v-model="newCatalogCategory" class="endpoint-input">
                  <option disabled value="">Category</option>
                  <option value="catalog">Global Catalog</option>
                  <option value="marketplace">Global Marketplace</option>
                </select>
              </div>
              <button
                class="add-btn"
                @click="addCatalog"
                :disabled="!newCatalogEndpoint.trim() || !newCatalogCategory"
              >
                <svg class="btn-icon" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 5v14M5 12h14"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
                Add Catalog
              </button>
            </div>

            <div class="input-row catalog-row">
              <!-- <div class="input-container select-container">
                <select v-model="newCatalogProtocol" class="endpoint-input">
                  <option disabled value="">Protocol</option>
                  <option value="EDC">EDC</option>
                  <option value="IDS">IDS</option>
                </select>
              </div> -->
              <!-- <div class="input-container">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M4 5h16M4 19h16M4 9h16M4 15h16"
                    stroke="currentColor"
                    stroke-width="2"
                  />
                </svg>
                <input
                  v-model="newCatalogDescription"
                  type="text"
                  placeholder="Optional description"
                  class="endpoint-input"
                />
              </div> -->
            </div>

            <p class="input-hint">
              These entries will appear in the Publish Offer modal as global
              destinations.
            </p>
          </div>
        </div>

        <div v-if="catalogs.length > 0" class="subscriptions-section">
          <h3 class="subscriptions-title">Your Catalogs & Marketplaces</h3>
          <div class="subscriptions-list">
            <div
              v-for="(catalog, index) in catalogs"
              :key="catalogKey(catalog, index)"
              class="catalog-card"
            >
              <Panel
                toggleable
                @toggle="onToggle($event, catalog)"
                :collapsed="true"
              >
                <template #header>
                  <div class="subscription-item">
                    <div class="subscription-content">
                      <svg
                        class="subscription-icon"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                          stroke="currentColor"
                          stroke-width="2"
                        />
                      </svg>
                      <div class="subscription-details">
                        <span class="endpoint-url">{{ catalog.name }}</span>
                        <span class="participant-did">{{
                          catalog.endpoint
                        }}</span>
                        <span class="subscription-status">
                          {{
                            catalog.category === "marketplace"
                              ? "Marketplace"
                              : "Global Catalog"
                          }}
                          · {{ catalog.protocol || "EDC" }}
                        </span>
                        <span
                          v-if="catalog.description"
                          class="subscription-meta"
                        >
                          {{ catalog.description }}
                        </span>
                      </div>
                    </div>
                    <button
                      class="configure-btn"
                      @click="openMetadataWizard(catalog)"
                      title="Configure metadata defaults"
                    >
                      Metadata Defaults
                    </button>
                    <button
                      class="unsubscribe-btn"
                      @click="removeCatalog($event, index)"
                      title="Remove catalog"
                    >
                      <svg
                        class="unsubscribe-icon"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M18 6L6 18M6 6l12 12"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                        />
                      </svg>
                    </button>
                  </div>
                </template>
                <div v-if="pullAssets" class="pull-panel">
                  <div class="pull-panel-header"></div>

                  <div
                    v-if="assetsFromGlobalCatalog.length === 0"
                    class="empty-pull"
                  >
                    No assets available for this catalog yet.
                  </div>

                  <div v-else class="pull-grid">
                    <div
                      v-for="asset in assetsFromGlobalCatalog"
                      :key="asset.id"
                      class="pull-asset-card"
                    >
                      <div class="pull-asset-body">
                        <div class="pull-title-row">
                          <h4>{{ asset.name }}</h4>
                          <span class="pull-tag">{{ asset.id }}</span>
                        </div>
                        <p>
                          {{ asset.description || "No description provided." }}
                        </p>
                        <div class="pull-meta">
                          <span>Endpoint: {{ asset.endpoint }}</span>
                          <span v-if="asset.participantId">
                            Participant: {{ asset.participantId }}
                          </span>
                        </div>
                        <div class="pull-chips">
                          <span
                            v-for="tag in asset.keywords"
                            :key="tag"
                            class="chip"
                          >
                            {{ tag }}
                          </span>
                          <span
                            v-for="tag in asset.theme"
                            :key="tag"
                            class="chip ghost"
                          >
                            {{ tag }}
                          </span>
                        </div>
                        <div
                          style="
                            padding: 30px 0 30px 0;
                            display: flex;
                            gap: 10px;
                          "
                        >
                          <Button label="Details" />
                          <Button
                            label="Request Access"
                            @click="$emit('request-access', asset)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Panel>
            </div>
          </div>
        </div>

        <div v-else class="empty-subscriptions">
          <div class="empty-icon">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                stroke="currentColor"
                stroke-width="2"
              />
            </svg>
          </div>
          <h3 class="empty-title">No global destinations</h3>
          <p class="empty-description">
            Add a global catalog or marketplace to populate the publish targets.
          </p>
        </div>
      </div>
    </section>
  </div>

  <transition name="modal">
    <div
      v-if="showFieldPopup"
      class="modal-overlay"
      @click.self="closeMetadataWizard"
    >
      <div class="modal-card">
        <div class="modal-header">
          <h2>Set Default Values</h2>
          <p class="modal-context">
            Catalog: {{ selectedCatalog?.name || selectedCatalog?.endpoint }}
          </p>
          <p class="modal-subtitle">
            Leave any field empty to keep it unset by default.
          </p>
        </div>
        <div class="modal-content">
          <div class="fields-grid">
            <div
              v-for="field in schemaFields"
              :key="field.name"
              class="field-card"
            >
              <div class="field-tag-row">
                <span class="field-name">{{ field.name }}</span>
                <span
                  class="field-required"
                  :class="{ optional: !field.required }"
                >
                  {{ field.required ? "Required" : "Optional" }}
                </span>
              </div>
              <div class="input-container modal-input">
                <input
                  v-if="inferFieldType(field) !== 'boolean'"
                  v-model="fieldInputs[field.name]"
                  :type="inferFieldType(field) === 'number' ? 'number' : 'text'"
                  class="endpoint-input"
                  :placeholder="`Default value for ${field.name}`"
                />
                <select
                  v-else
                  v-model="fieldInputs[field.name]"
                  class="endpoint-input"
                >
                  <option value="">No default</option>
                  <option value="true">true</option>
                  <option value="false">false</option>
                </select>
              </div>
            </div>
          </div>
          <p class="modal-hint">
            These values will be saved in the generated payload under
            <code>catalogSpecificMetadata</code>.
          </p>
        </div>
        <div class="modal-actions">
          <button class="ghost-btn" @click="closeMetadataWizard">Cancel</button>
          <div v-if="defaultValueExist">
            <button class="add-btn" @click="editFieldDefaults">
              Edit Values
            </button>
          </div>
          <div v-else>
            <button class="add-btn" @click="saveFieldDefaults">
              Set Values
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, computed, watch } from "vue";
import axios from "axios";
import { useConfirm } from "primevue/useconfirm";
import ConfirmPopup from "primevue/confirmpopup";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import { userService } from "../services/UserService";
import Panel from "primevue/panel";
import Button from "primevue/button";

const toast = useToast();

const { appContext } = getCurrentInstance();
const API_BASE_URL = appContext.config.globalProperties.$apiBase;

const props = defineProps({
  user: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["refresh-catalogs", "request-access"]);

const confirm = useConfirm();

const newCatalogName = ref("");
const newCatalogEndpoint = ref("");
const newCatalogCategory = ref("");
const newCatalogProtocol = ref("");
const newCatalogDescription = ref("");
const token = userService.getCookie("ZDZW_cookie");
const user = userService.getCookieUser().organization[0];
const pullAssets = ref(false);
const assetsFromGlobalCatalog = ref([]);

const catalogs = ref([]);
const portalCatalogs = ref([]);
const selectedPortalCatalogId = ref("");

const showFieldPopup = ref(false);
const selectedCatalog = ref(null);
const schemaFields = ref([]);
const objectId = ref("");
const defaultValueExist = ref(false);
const fieldDefaults = ref({});
const fieldInputs = ref({});

const onToggle = (event, catalog) => {
  console.log("Panel toggled:", event);
  console.log("Collapsed?", event.value); // true = collapsed, false = expanded
  togglePullCatalog(catalog);
};

const inferFieldType = (field) => {
  const fieldName = field?.name || "";
  if (/^(is|has)[A-Z_]/.test(fieldName)) return "boolean";
  if (/score|count|total|amount|number|size|price/i.test(fieldName))
    return "number";
  return "text";
};

const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
};

const fetchPortalCatalogs = async () => {
  try {
    const response = await axios.get(
      "https://portal-api.ds2.icelab.cloud/organization/catalog",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    portalCatalogs.value = Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error("Error fetching portal catalogs:", error);
    toast.add({
      severity: "error",
      summary: "Portal Error",
      detail: "Unable to load portal catalogs.",
      life: 2500,
    });
  }
};

const handlePortalCatalogSelect = () => {
  const selected = portalCatalogs.value.find(
    (catalog) => catalog.id === selectedPortalCatalogId.value
  );

  console.log("Selected catalog: ", selected);

  if (!selected) {
    newCatalogEndpoint.value = "";
    newCatalogCategory.value = "";
    newCatalogName.value = "";
    return;
  }

  newCatalogEndpoint.value = selected.url || "";
  newCatalogCategory.value =
    selected.catalogType === "catalog" ? "catalog" : "marketplace";
  newCatalogName.value = selected.name || "";
};

watch(selectedPortalCatalogId, () => {
  handlePortalCatalogSelect();
});

const addCatalog = async () => {
  if (!newCatalogEndpoint.value.trim() || !newCatalogCategory.value) {
    return;
  }

  if (!isValidUrl(newCatalogEndpoint.value)) {
    toast.add({
      severity: "error",
      summary: "Error Message",
      detail: "Please enter a valid URL starting with http:// or https://",
      life: 3000,
    });
    return;
  }

  if (
    catalogs.value.some(
      (entry) =>
        entry.endpoint === newCatalogEndpoint.value &&
        entry.category === newCatalogCategory.value
    )
  ) {
    toast.add({
      severity: "error",
      summary: "Error Message",
      detail: "This catalog is already added.",
      life: 3000,
    });
    return;
  }

  try {
    const response = await axios.post(
      `${API_BASE_URL}/users/${props.user}/catalogs`,
      {
        endpoint: newCatalogEndpoint.value,
        category: newCatalogCategory.value,
        name: newCatalogName.value,
      }
    );

    await fetchCatalogs(props.user);
    toast.add({
      severity: "success",
      summary: "Catalog Added",
      life: 3000,
    });
    emit("refresh-catalogs");

    const newCatalog = response?.data?.catalogs?.find(
      (entry) =>
        entry.endpoint === newCatalogEndpoint.value &&
        entry.category === newCatalogCategory.value
    );

    openMetadataWizard(
      newCatalog || {
        name: newCatalogEndpoint.value,
        endpoint: newCatalogEndpoint.value,
        category: newCatalogCategory.value,
      }
    );

    //newCatalogName.value = "";
    newCatalogEndpoint.value = "";
    newCatalogCategory.value = "";
    selectedPortalCatalogId.value = "";
    //newCatalogProtocol.value = "";
    //newCatalogDescription.value = "";
  } catch (error) {
    console.error("Error adding catalog:", error);
    toast.add({
      severity: "error",
      summary: "Error Message",
      detail: error.response.data.detail,
      life: 3000,
    });
  }
};

const fetchCatalogs = async (user) => {
  try {
    const res = await axios.get(`${API_BASE_URL}/users/${user}/catalogs`);
    console.log("API response for catalogs:", res);

    catalogs.value = res.data;
    console.log("Fetched catalogs:", catalogs.value);
  } catch (error) {
    console.error("Error fetching catalogs:", error);
  }
};

const getCatalogSchema = async (catalog) => {
  // Placeholder for upcoming catalog schema API integration.
  // Expected API response shape:
  // { fields: [{ name: "carbonFootprintScore", required: true }, ...] }
  return {
    fields: [
      { name: "carbonFootprintScore", required: true },
      { name: "OrganisationName", required: true },
      { name: "isPayable", required: true },
      { name: "colour", required: false },
    ],
  };
};

const openMetadataWizard = async (catalog) => {
  try {
    console.log("Loading metadata schema for catalog:", catalog);
    selectedCatalog.value = catalog;
    const schema = await getCatalogSchema(catalog);
    schemaFields.value = Array.isArray(schema?.fields) ? schema.fields : [];
    fieldDefaults.value = {};
    fieldInputs.value = schemaFields.value.reduce((acc, field) => {
      acc[field.name] = "";
      return acc;
    }, {});

    console.log("field inputs initialized to:", fieldInputs.value);

    const response = await axios.post(
      `${API_BASE_URL}/repository/find/prop/${props.user}`,
      {
        objectType: {
          name: "globalCatalog",
        },
        name: catalog.name,
      },
      {
        params: {
          includeContent: "true",
          pageNumber: 1,
          pageSize: 100,
          sortBy: "_id",
        },
      }
    );

    console.log(
      "Repository search response for existing metadata:",
      response.data
    );

    if (response.data.length > 0) {
      fieldInputs.value = response.data[0].contentData.defaultValues || {};
      defaultValueExist.value = true;
      objectId.value = response.data[0].id;
    }

    console.log("field inputs initialized after:", fieldInputs.value);

    if (!schemaFields.value.length) {
      toast.add({
        severity: "warn",
        summary: "No Schema Fields",
        detail: "Schema API returned no fields for this catalog.",
        life: 3000,
      });
      return;
    }
    showFieldPopup.value = true;
  } catch (error) {
    console.error("Error loading metadata schema:", error);
    toast.add({
      severity: "error",
      summary: "Schema Error",
      detail: "Unable to load metadata schema for this catalog.",
      life: 3000,
    });
  }
};

const closeMetadataWizard = () => {
  showFieldPopup.value = false;
  fieldInputs.value = {};
};

const castFieldValue = (value, type) => {
  if (type === "boolean") return value === "true";
  if (type === "number") return Number(value);
  return value;
};

const saveFieldDefaults = async () => {
  const defaults = {};

  schemaFields.value.forEach((field) => {
    const rawValue = (fieldInputs.value[field.name] ?? "").toString().trim();
    if (!rawValue) return;
    defaults[field.name] = castFieldValue(rawValue, inferFieldType(field));
  });

  fieldDefaults.value = defaults;

  const payload = buildCatalogMetadataPayload();
  console.log("Generated metadata payload:", payload);

  const response = await axios.post(
    `${API_BASE_URL}/repository/insert`,
    payload
  );

  console.log("Payload upload response:", response.data);

  closeMetadataWizard();
  toast.add({
    severity: "success",
    summary: "Payload Ready",
    detail: "Metadata payload generated. Copy and upload it to your database.",
    life: 3000,
  });
};

const editFieldDefaults = async () => {
  const defaults = {};

  schemaFields.value.forEach((field) => {
    const rawValue = (fieldInputs.value[field.name] ?? "").toString().trim();
    if (!rawValue) return;
    defaults[field.name] = castFieldValue(rawValue, inferFieldType(field));
  });

  fieldDefaults.value = defaults;

  const payload = buildCatalogMetadataPayload();
  console.log("Generated metadata payload:", payload);

  const response = await axios.post(
    `${API_BASE_URL}/repository/update/full`,
    payload
  );

  console.log("Payload upload response:", response.data);

  closeMetadataWizard();
  toast.add({
    severity: "success",
    summary: "Payload Ready",
    detail: "Metadata payload generated. Copy and upload it to your database.",
    life: 3000,
  });
};

const buildCatalogMetadataPayload = () => {
  return {
    ownerId: props.user,
    externalId: selectedCatalog.value?.id,
    objectType: {
      name: "globalCatalog",
      level: 0,
    },
    name: selectedCatalog.value?.name || selectedCatalog.value?.endpoint,
    description: selectedCatalog.value?.description,
    comments: "",
    version: "",
    tags: [],
    metadata: {},
    contentType: "json",
    contentData: {
      fields: schemaFields.value,
      defaultValues: fieldDefaults.value,
      generatedAt: new Date().toISOString(),
    },
    ...(defaultValueExist.value && { id: objectId.value }), // 👈 here
  };
};

const copyPayload = async (payload) => {
  try {
    await navigator.clipboard.writeText(JSON.stringify(payload, null, 2));
    toast.add({
      severity: "success",
      summary: "Copied",
      detail: "Payload copied to clipboard.",
      life: 2000,
    });
  } catch (error) {
    console.error("Failed to copy payload:", error);
    toast.add({
      severity: "error",
      summary: "Copy Failed",
      detail: "Unable to copy payload to clipboard.",
      life: 2000,
    });
  }
};

const togglePullCatalog = async (catalog) => {
  pullAssets.value = !pullAssets.value;
  assetsFromGlobalCatalog.value = [];
  console.log("Toggle pull for catalog:", catalog);
  try {
    const response = await axios.post(
      `${API_BASE_URL}/repository/find/prop/${props.user}`,
      {
        objectType: {
          name: "DS2DataOfferPackage",
        },
      },
      {
        params: {
          includeContent: "true",
          pageNumber: 1,
          pageSize: 100,
          sortBy: "_id",
        },
      }
    );
    console.log("Repository search response for policies:", response.data);

    const catalogAssets =
      response.data.find((record) => record.externalId === catalog.name)
        ?.contentData || [];

    console.log("Assets for catalog from repository search:", catalogAssets);

    const payload = {
      catalog: catalogAssets,
    };
    const assetRes = await axios.post(`${API_BASE_URL}/assets`, payload);
    assetsFromGlobalCatalog.value = assetRes.data || [];

    console.log(
      "Assets for catalog after toggle:",
      assetsFromGlobalCatalog.value
    );
  } catch (error) {
    console.error("Error toggling pull panel:", error);
  }
};

const removeCatalog = async (event, index) => {
  const catalog = catalogs.value[index];

  confirm.require({
    target: event.currentTarget,
    message: "Do you want to delete this record?",
    icon: "pi pi-info-circle",
    rejectProps: {
      label: "Cancel",
      severity: "secondary",
      outlined: true,
    },
    acceptProps: {
      label: "Delete",
      severity: "danger",
    },
    accept: async () => {
      console.log("Delete clicked");
      const response = await axios.post(
        `${API_BASE_URL}/repository/find/prop/${user}`,
        { objectType: { name: "User" } },
        {
          params: {
            includeContent: "true",
            pageNumber: 1,
            pageSize: 200,
            sortBy: "_id",
          },
        }
      );
      console.log(response.data);
      const userRecord = response.data.find((record) => record.name === user);
      console.log("userRecord:", userRecord);
      console.log("catalog to remove:", catalog);
      console.log(
        "userRecord content catalogs before:",
        userRecord.contentData?.catalogs
      );
      userRecord.contentData.catalogs = userRecord.contentData.catalogs.filter(
        (entry) => {
          return !(
            entry.endpoint === catalog.endpoint &&
            entry.category === catalog.category
          );
        }
      );

      await axios.post(`${API_BASE_URL}/repository/update/full`, userRecord);

      const catalogResponse = await axios.post(
        `${API_BASE_URL}/repository/find/prop/${user}`,
        { objectType: { name: "globalCatalog" } },
        {
          params: {
            includeContent: "true",
            pageNumber: 1,
            pageSize: 200,
            sortBy: "_id",
          },
        }
      );

      console.log("Catalog records response:", catalogResponse.data);
      console.log("Catalog to match:", catalog);

      const globalCatalogRecord = catalogResponse.data.find(
        (record) => record.name === catalog.name
      );
      console.log("Global Catalog Records:", globalCatalogRecord);

      const catalogRes = await axios.delete(
        `${API_BASE_URL}/repository/delete/${globalCatalogRecord.id}`,
        {
          params: {
            file_id: globalCatalogRecord.id,
          },
        }
      );

      if (catalogRes.data.acknowledged) {
        await fetchCatalogs(props.user);
        toast.add({
          severity: "warn",
          summary: "Catalog removed",
          life: 3000,
        });
      }

      // await axios.post(`${API_BASE_URL}/users/${props.user}/catalogs/remove`, {
      //   name: catalog.name,
      //   endpoint: catalog.endpoint,
      //   category: catalog.category,
      // });
      // await fetchCatalogs(props.user);
      // emit("refresh-catalogs");
    },
  });
};

const catalogKey = (catalog, index) => {
  return `${catalog.endpoint}-${catalog.category}-${index}`;
};

onMounted(async () => {
  await fetchCatalogs(props.user);
  await fetchPortalCatalogs();
});
</script>

<style scoped>
.subscriber-view {
  --brand-primary: #0f766e;
  --brand-primary-strong: #115e59;
  --brand-soft: #f0fdfa;
  --slate-100: #e2e8f0;
  --slate-200: #cbd5e0;
  --slate-500: #64748b;
  --modal-backdrop: rgba(15, 23, 42, 0.58);
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
  font-family: "Manrope", "Segoe UI", sans-serif;
  color: #2d3748;
}

.header-section {
  background: linear-gradient(135deg, var(--brand-primary) 0%, #155e75 100%);
  border-radius: 16px;
  padding: 2.5rem;
  margin-bottom: 3rem;
  color: white;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.2);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 2rem;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.title {
  font-size: 2.25rem;
  font-weight: 700;
  margin: 0;
  color: white;
}

.catalog-badge {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
}

.subscription-section {
  margin-bottom: 3rem;
}

.subscription-card {
  background: radial-gradient(circle at 90% -20%, #ccfbf1 0%, transparent 32%),
    white;
  border: 1px solid var(--slate-100);
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.card-header {
  margin-bottom: 2rem;
}

.section-description {
  font-size: 1rem;
  color: black;
  margin: 0;
  line-height: 1.6;
}

.input-section {
  margin-bottom: 2.5rem;
}

.input-group {
  max-width: 900px;
}

.input-row {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 0.75rem;
}

.catalog-row {
  grid-template-columns: 1fr 1fr 220px;
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.5rem;
  transition: all 0.3s ease;
}

.input-container:focus-within {
  border-color: #009688;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.select-container {
  padding: 0.5rem 0.75rem;
}

.input-icon {
  width: 20px;
  height: 20px;
  color: #a0aec0;
  margin: 0 0.75rem;
  flex-shrink: 0;
}

.endpoint-input {
  flex: 1;
  border: none;
  background: transparent;
  padding: 0.75rem 0;
  font-size: 1rem;
  color: #2d3748;
  outline: none;
}

.endpoint-input::placeholder {
  color: #a0aec0;
}

.add-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--brand-primary);
  color: black;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.25rem;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  height: fit-content;
}

.add-btn:hover:not(:disabled) {
  background: var(--brand-primary-strong);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.add-btn:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.btn-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.input-hint {
  font-size: 0.85rem;
  color: #718096;
  margin: 0;
}

.subscriptions-section {
  border-top: 1px solid #e2e8f0;
  padding-top: 2rem;
}

.payload-section {
  margin-top: 2rem;
  border-top: 1px solid var(--slate-100);
  padding-top: 2rem;
}

.payload-list {
  display: grid;
  gap: 1rem;
}

.payload-card {
  border: 1px solid var(--slate-100);
  border-radius: 14px;
  background: #ffffff;
  overflow: hidden;
}

.payload-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem 1rem 0.75rem 1rem;
}

.payload-title {
  margin: 0;
  font-size: 1rem;
}

.payload-subtitle {
  margin: 0.2rem 0 0;
  color: var(--slate-500);
  font-size: 0.82rem;
  word-break: break-all;
}

.payload-json {
  margin: 0;
  padding: 1rem;
  background: #0f172a;
  color: #cbd5e1;
  font-size: 0.76rem;
  max-height: 280px;
  overflow: auto;
}

.copy-btn,
.configure-btn {
  border: 1px solid var(--slate-200);
  border-radius: 8px;
  background: #ffffff;
  color: #0f172a;
  cursor: pointer;
  font-weight: 700;
  font-size: 0.78rem;
}

.copy-btn {
  padding: 0.45rem 0.65rem;
}

.configure-btn {
  padding: 0.45rem 0.7rem;
  margin-left: auto;
}

.copy-btn:hover,
.configure-btn:hover {
  border-color: var(--brand-primary);
  color: var(--brand-primary-strong);
}

.pull-toggle {
  border: 1px solid var(--slate-200);
  border-radius: 8px;
  background: #ffffff;
  color: #0f172a;
  cursor: pointer;
  font-weight: 700;
  font-size: 0.78rem;
  padding: 0.45rem 0.7rem;
  margin-left: 0.5rem;
}

.pull-toggle:hover {
  border-color: var(--brand-primary);
  color: var(--brand-primary-strong);
}

.subscriptions-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 1.5rem 0;
}

.subscriptions-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.catalog-card {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.subscription-item {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  transition: all 0.2s ease;
}

.subscription-content {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
}

.subscription-icon {
  width: 20px;
  height: 20px;
  color: #48bb78;
  flex-shrink: 0;
}

.subscription-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
}

.endpoint-url {
  font-weight: 500;
  color: #2d3748;
  font-size: 0.95rem;
}

.participant-did {
  font-size: 0.85rem;
  color: #718096;
  font-family: monospace;
}

.subscription-status {
  font-size: 0.8rem;
  color: var(--brand-primary);
  font-weight: 600;
  margin-top: 0.25rem;
}

.subscription-meta {
  font-size: 0.85rem;
  color: #718096;
}

.unsubscribe-btn {
  background: #fed7d7;
  border: none;
  border-radius: 8px;
  padding: 0.5rem;
  color: #e53e3e;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  margin-left: 1rem;
}

.unsubscribe-btn:hover {
  background: #feb2b2;
  transform: scale(1.05);
}

.unsubscribe-icon {
  width: 16px;
  height: 16px;
}

.empty-subscriptions {
  text-align: center;
  padding: 3rem 2rem;
  border-top: 1px solid #e2e8f0;
}

.empty-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 1.5rem;
  background: #f7fafc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a0aec0;
}

.empty-icon svg {
  width: 32px;
  height: 32px;
}

.empty-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 0.5rem 0;
}

.empty-description {
  color: #718096;
  margin: 0;
  font-size: 0.95rem;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--modal-backdrop);
  display: grid;
  place-items: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-card {
  width: min(620px, 100%);
  border-radius: 18px;
  border: 1px solid #dbeafe;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 30px 70px rgba(2, 8, 23, 0.35);
}

.modal-header {
  padding: 1.35rem 1.35rem 0.6rem;
}

.modal-header h2 {
  margin: 0.15rem 0;
  font-size: 1.4rem;
}

.modal-subtitle {
  margin: 0.2rem 0 0;
  color: #4a5568;
  font-size: 0.9rem;
}

.modal-step {
  margin: 0;
  color: var(--brand-primary-strong);
  font-weight: 800;
  font-size: 0.82rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.modal-context {
  margin: 0;
  color: var(--slate-500);
  font-size: 0.9rem;
}

.modal-content {
  padding: 1rem 1.35rem;
}

.fields-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
}

.field-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.field-card .input-container {
  margin: 0;
}

.field-tag-row {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 0.8rem;
}

.field-name {
  font-weight: 800;
  font-size: 1rem;
  color: #0f172a;
}

.field-required {
  background: #dcfce7;
  color: #166534;
  border-radius: 999px;
  font-size: 0.74rem;
  padding: 0.22rem 0.55rem;
  font-weight: 700;
}

.field-required.optional {
  background: #e2e8f0;
  color: #334155;
}

.modal-input {
  background: #fff;
  margin-bottom: 0.5rem;
}

.modal-hint {
  margin: 0.45rem 0 0;
  color: var(--slate-500);
  font-size: 0.82rem;
}

.modal-actions {
  padding: 0 1.35rem 1.3rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.7rem;
}

.ghost-btn {
  border-radius: 8px;
  border: 1px solid var(--slate-200);
  background: #fff;
  color: #334155;
  padding: 0.75rem 1rem;
  font-weight: 700;
  cursor: pointer;
}

.ghost-btn:hover {
  border-color: var(--slate-500);
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

@media (max-width: 900px) {
  .catalog-row {
    grid-template-columns: 1fr;
  }

  .input-row {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .add-btn {
    justify-content: center;
    margin-top: 0.5rem;
  }
}

@media (max-width: 768px) {
  .subscriber-view {
    padding: 1rem;
  }

  .title {
    font-size: 2rem;
  }

  .subscription-card {
    padding: 1.5rem;
  }

  .subscription-item {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }

  .subscription-content {
    gap: 0.75rem;
  }

  .unsubscribe-btn {
    margin-left: 0;
    align-self: flex-end;
  }
}

@media (max-width: 480px) {
  .title {
    font-size: 1.75rem;
  }

  .subscription-card {
    padding: 1.25rem;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.subscription-item {
  animation: fadeIn 0.3s ease forwards;
}

/* Pull Panel */
.pull-panel {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  padding: 1.25rem;
}

.pull-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
  gap: 1rem;
}

.pull-panel-header h4 {
  margin: 0 0 0.3rem;
  font-size: 1.05rem;
  color: #0f172a;
}

.pull-panel-header p {
  margin: 0;
  font-size: 0.85rem;
  color: #64748b;
}

.pull-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.empty-pull {
  padding: 1rem;
  border-radius: 12px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 0.9rem;
}

.pull-grid {
  display: grid;
  gap: 1.2rem;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
}

.catalog-pill {
  background: #e2e8f0;
  color: #334155;
  padding: 0.3rem 0.75rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
}

.pull-asset-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 1.25rem;
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.pull-asset-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
}

.pull-checkbox {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.pull-checkbox input {
  opacity: 0;
  position: absolute;
}

.checkbox-mark {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 2px solid #94a3b8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: white;
}

.pull-checkbox input:checked + .checkbox-mark {
  border-color: var(--brand-primary);
  background: var(--brand-primary);
  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.18);
}

.pull-checkbox input:checked + .checkbox-mark::after {
  content: "";
  width: 8px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  margin-top: -2px;
}

.pull-asset-body h4 {
  margin: 0;
  font-size: 1.05rem;
  color: #0f172a;
}

.pull-title-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 0.35rem;
}

.pull-tag {
  background: #e2e8f0;
  color: #475569;
  border-radius: 999px;
  padding: 0.2rem 0.65rem;
  font-size: 0.75rem;
  font-weight: 600;
}

.pull-asset-body p {
  margin: 0 0 0.7rem;
  color: #475569;
  font-size: 0.9rem;
}

.pull-meta {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.78rem;
  color: #64748b;
  margin-bottom: 0.6rem;
  word-break: break-word;
}

.pull-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.chip {
  background: #0f766e;
  color: white;
  padding: 0.15rem 0.6rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
}

.chip.ghost {
  background: #e0f2fe;
  color: #0369a1;
}

.selected-assets {
  margin-top: 2rem;
  border-top: 1px solid #e2e8f0;
  padding-top: 1.5rem;
}

.selected-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.selected-header h4 {
  margin: 0;
  font-size: 1.1rem;
  color: #0f172a;
}

.selected-header span {
  font-size: 0.85rem;
  color: #64748b;
}

.selected-list {
  display: grid;
  gap: 0.75rem;
}

.selected-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.9rem 1rem;
}

.selected-item p {
  margin: 0.25rem 0 0;
  font-size: 0.78rem;
  color: #64748b;
  word-break: break-word;
}

@media (max-width: 900px) {
  .pull-toggle {
    margin-left: 0;
  }
}
</style>
